import { render, staticRenderFns } from "./video_modify.vue?vue&type=template&id=0a8e6837&"
import script from "./video_modify.vue?vue&type=script&lang=js&"
export * from "./video_modify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports